<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Roles" resource="roles" primaryKey="idrol"
        :records="records" :meta="meta" :columns="columns" readonly="true" />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import RolService from "@/services/rol.service";
import { rol } from "@/models/rol";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: rol.filter(column => column.showOnList)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        RolService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
